import React from "react";

export const LdasCountBadge = ({ count }) => {
  const className =
    count > 0
      ? "ldas-count-badge ldas-count-badge--active"
      : "ldas-count-badge";
  return <span className={className}>{count}</span>;
};

export const LdasCategoryBadge = ({ label }) => {
  return <span className="ldas-category-badge">{label}</span>;
};

/** SweetAlert2 공통 옵션 — title/text만 호출부에서 덮어쓰기 */
export const LDAS_DELETE_SWAL_CONFIG = {
  icon: "warning",
  showCloseButton: true,
  closeButtonAriaLabel: "닫기",
  showCancelButton: true,
  reverseButtons: true,
  buttonsStyling: false,
  confirmButtonText: "삭제",
  cancelButtonText: "취소",
  customClass: {
    popup: "ldas-swal-popup--wide",
    actions: "ldas-swal-actions--equal",
    confirmButton: "ldas-swal-confirm",
    cancelButton: "ldas-swal-cancel",
  },
};

/** LDAS 페이지네이션 API 응답 → 목록 페이지 state (Spring Page / 커스텀 items·totalCount 호환) */
export const normalizeLdasListPage = (res, prevPageable) => {
  const r = res?.result;
  return {
    content: r?.content ?? r?.items ?? [],
    pageable: {
      pageNumber: r?.number ?? r?.page ?? prevPageable.pageNumber,
      pageSize: r?.size ?? prevPageable.pageSize,
    },
    totalElements: r?.totalElements ?? r?.totalCount ?? 0,
  };
};
